import { each } from "lodash";
import "lightgallery.js";

import { app } from '../utils/store';

export default class LightBox{
    constructor(){
        this.header = document.querySelector('header');

        this.material = {
            container: document.getElementById('finishing'),
            image: document.querySelectorAll('#finishing img'),
        };

        this.lightbox = {
            container: document.querySelectorAll('.lightbox'),
            toggler: document.querySelectorAll('.lightbox li'),
        };
        
        if(this.material.container){
            this.toggle();
        }
    }

    toggle = () => {
        document.querySelector('body').classList.add('lg-materials');

        each(this.lightbox.container,(lightbox) => {
            lightGallery(lightbox, {
                mode: 'lg-fade',
                startClass: 'lg-start-fade',
                keypress: true,
                controls: true,
                download: false,
                counter: false,
                enableDrag: true,
                enableTouch: false,
                enableSwipe: true,
                subHtmlSelectorRelative: true,
                useLeft: true,
                hideControlOnEnd: true,
            });

            lightbox.addEventListener('onBeforeOpen', () => {
                this.header.classList.add('lg-active');
                document.querySelector('body').classList.toggle('overflow-hidden');
            });
    
            lightbox.addEventListener('onBeforeClose', () => {
                this.header.classList.remove('lg-active');
                document.querySelector('body').classList.toggle('overflow-hidden');
            });
        })

        each(this.material.image,(toggler) => {
            toggler.addEventListener('click', (e) => {
                var target = e.target.getAttribute('data-src');
                document.querySelector('.lightbox [data-src="' + target + '"').click();
                document.body.classList.add('overflow-hidden')
                document.body.classList.add('modal-active')
            });
        })
    }
}
